import React from 'react';
import { connect } from 'react-redux';
import { reduxForm, Field } from 'redux-form';
import moment from 'moment';
import { withTranslation } from 'react-i18next';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { Typography } from './../../../../assets/theme/default';
import { Grid } from './../../../../assets/theme/layout';
import { Content, Toolbar, Button, ButtonsGroup, Loading, Modal, Date } from './../../../../components/ui';
import { InputDateField, SelectField, OptionField } from './../../../../components/ui/input';
import { SupportService } from './../../../../services';

import API from './../../../../config/api';

const validate = values => {
  const errors = {};
  return errors;
};

class SettingSupport extends React.Component {

  constructor(props){
    super(props);
    this.state = {
      loading: false,
      submited: false,
      entity: null,
      exportGeneratedShow: false,
      identifiers: []
    };
  };

  /**
* @Event
* @Description: Is invoked immediately after a component is mounted.
*/
  componentDidMount() {
    this._Init();
  };

  /*
  ** @Event
  ** @Description: Init
  */

  _Init = () => {

    // @Service
    this._Identifiers();

  };

  /*
  ** @Service
  ** @Description: Find Identifiers
  */

  _Identifiers = () => {

    SupportService.identifiers().then((response) => {

      // @State
      // @Description:
      this.setState({
        identifiers: response.identifiers || []
      });

    }).catch((error) => {
      console.log(error);
    });

  };

  /*
  ** @Service
  ** @Description: Export subscriptions
  */
  _Export = (values) => {

    // @State
    // @Description: Set loading show
    this.setState({ loading: false });

    // @Service
    // @Description:
    SupportService.generateTokenReport(values).then((response) => {

      // @State
      // @Description: Set response
      this.setState({
        loading: false,
        entity: response,
        exportGeneratedShow: true
      });

    }).catch((error) => {

      // @State
      // @Description: Set loading hide
      this.setState({ loading: false });

      // @Dispatch
      // @Description: Show alert error
      this.props.alertShow({
        open: true,
        severity: 'error',
        message: error.data.message
      });

    });

  };

  /*
  ** @Submit
  ** @Description: Submit form
  */
  handleSubmitForm = (values) => {
    this._Export(values);
  };

  /*
  ** @Event
  ** @Description: Close exported
  */
  handleExportGeneratedClose = () => {
    this.setState({ exportGeneratedShow: false });
  };

  render(){

    const { handleSubmit, invalid } = this.props;
    const { loading, submited, entity, identifiers, exportGeneratedShow } = this.state;

    return(
      <React.Fragment>
        <Toolbar
          title={this.props.t('page.settings.support.title')}
          subtitle={this.props.t('page.settings.support.subtitle')}
          size="medium"
          variant="divider"
          disableMargin
        />

        <Modal
            status={ exportGeneratedShow }
            title={this.props.t('page.settings.support.subtitle')}
            handleCancel={ () => this.handleExportGeneratedClose() }
            maxWidth="sm">
            <Content disablePadding disableMargin>
              {entity && (
                <React.Fragment>
                  <Content disablePadding divider>
                    <Typography align="center" variant="body2">
                      <strong>{this.props.t('text.export_text_1')}</strong>
                      <br/>
                      {this.props.t('text.export_text_2')}
                      <br/>
                      ({this.props.t('text.export_text_3')} <Date value={ moment.unix(entity.exp).format() } format="DD/MM/YYYY hh:mm a"/>)
                    </Typography>
                  </Content>
                  <Content disablePadding>
                    <ButtonsGroup align="center">
                      <Button
                        color="primary"
                        size="medium"
                        component="a"
                        target="_blank"
                        href={ `${ API.endpoint.services }/support/report/download/${ entity.token }` }
                      >
                        {this.props.t('button.download')}
                      </Button>
                      <CopyToClipboard
                        text={ `${ API.endpoint.services }/support/report/download/${ entity.token }` }
                        onCopy={ this.handleCopyLink }
                      >
                        <Button color="primary" size="medium">
                          {this.props.t('button.copy')}
                        </Button>
                      </CopyToClipboard>
                      <Button
                        color="danger"
                        size="medium"
                        onClick={ this.handleExportGeneratedClose }
                      >
                        {this.props.t('button.cancel')}
                      </Button>
                    </ButtonsGroup>
                  </Content>
                </React.Fragment>
              )}
            </Content>
        </Modal>

        <form noValidate autoComplete="off" onSubmit={ handleSubmit(this.handleSubmitForm) }>

          {/* Body */}
          <Content divider disableMargin>

            { (submited || loading) && (
              <Loading variant="absolute"/>
            )}

            <Content marginBottom>
              <Grid container spacing={3}>
                <Grid item xl={4} lg={4} md={4} sm={6} xs={12}>
                  <Field
                    name="date_from"
                    component={ InputDateField }
                    label={this.props.t('field.since')}
                    type="text"
                    required
                  />
                </Grid>
                <Grid item xl={4} lg={4} md={4} sm={6} xs={12}>
                  <Field
                    name="date_to"
                    component={ InputDateField }
                    label={this.props.t('field.until')}
                    type="text"
                    disableFuture
                    required
                  />
                </Grid>
                <Grid item xl={4} lg={4} md={4} sm={12} xs={12}>
                  <Field
                      name="identifier"
                      component={ SelectField }
                      label={this.props.t('field.identifier')}>
                        <OptionField value="none">{this.props.t('field.option_field.all')}</OptionField>
                        { identifiers.map((identifier, index) => {
                          return(
                            <OptionField key={ index } value={ identifier }>
                              { identifier }
                            </OptionField>
                          )
                        })}
                  </Field>
                </Grid>
              </Grid>
            </Content>

          </Content>

          {/* Footer */}
          <Content>
            <ButtonsGroup align="right">
              <Button
                type="submit"
                size="medium"
                icon="add"
                color="success"
                disabled={ invalid || submited }
              >
                {this.props.t('button.confirm')}
              </Button>
            </ButtonsGroup>
          </Content>

        </form>

      </React.Fragment>
    )
  }

};

SettingSupport = reduxForm({
  form: 'SettingSupport',
  validate,
  initialValues: {
    date_from: moment().subtract(7, 'days').startOf('day').format(),
    date_to: moment().endOf('day').format()
  },
  enableReinitialize: true
})(SettingSupport);

const mapStateToProps = (state) => {
  return {
    session: state.userState
  }
};

const mapDispatchToProps = (dispatch) => {
  return {
    alertShow: (data) => {
      dispatch({
        type: 'ALERT_SHOW',
        data: data
      });
    }
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(SettingSupport));
